import React, { createRef } from "react";
import PopUp, { closePopUp } from "./popUp";
import { getApiUrl } from "../data/api/apiManager";
import Button from "./button";
import TrashBinIcon from "../assets/icons/trashBinIcon";
import UploadIcon from "../assets/icons/uploadIcon";
import { allowedImgFileFormats } from "./profilePicturePicker";

interface ProfilePicturePickerPopUpProps {
    onChange: (file: File[]) => void;
    file?: string;
    profilePictureContentHash: string;
}

export default function ProfilePicturePickerPopUp(props: ProfilePicturePickerPopUpProps) {

    const inputFile = createRef<HTMLInputElement>();
    
        const handleFileUpload = (e: any) => {
            e.preventDefault();
            const { files } = e.target;
            if (files && files.length) {
                props.onChange(files);
            }
            closePopUp();
          };


    return <PopUp title="Profile Picture" className="profile-picture-picker-popup">
        <input
            accept={allowedImgFileFormats.map(format => `.${format}`).join(",")}
            style={{ display: "none" }}
            // accept=".zip,.rar"
            ref={inputFile}
            onChange={handleFileUpload}
            type="file"
        />
        <img src={props.file ? props.file : getApiUrl("assets/by-hash/" + props.profilePictureContentHash)} className="profile-picture" alt="Profile" />
        <div className="buttons">
            <Button onClick={() => {
                inputFile.current?.click();
            }}><UploadIcon/>Upload New</Button>
            <Button onClick={() => {

            }}><TrashBinIcon/>Delete</Button>
        </div>
    </PopUp>
}

